import {
    apiGetClient,
    apiPostClient,
    apiPostImageClient,
    apiPutClient,
    apiPutImageClient,
} from "../../../api/apiSvtAdminCore";

import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);


export const getAllTemplates = async () => {
    try {
        const response = await apiGetClient.get(
            "template-masters?isImageRequired=true"
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewTemplate = async (data) => {
    try {
        const response = await apiPostImageClient.post(
            "template-masters",
            data
        );
    toast.success(t("templateCreatedSuccess", { name: data.get("Name") }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
                toast.error(t("templateAlreadyExistsError", { name: data.get("Name") || "unknown" }), { position: "top-center" });
        }
        return null;
    }
};

export const updateTemplate = async (data, id) => {
    try {
        const response = await apiPutImageClient.put(
            `template-masters/${id}`,
            data
        );
    toast.success(t("templateUpdatedSuccess", { name: data.get("Name") }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getTemplate = async () => {
    try {
        const response = await apiGetClient.get("template-masters/get");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSasTokenForTemplateMaster = async () => {
    try {
        const response = await apiGetClient.get(
            "template-masters/template-master-images/sas"
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};
